import * as React from 'react'

type LayoutProps = {
  title: string,
  desc: string
}

export default class Layout extends React.Component<LayoutProps> {
  render() {
    const { title, desc, children } = this.props
    return (
      <div className="app flex-row align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="clearfix">
                <h1 className="float-left display-3 mr-4">{title}</h1>
                <h4 className="pt-3">{desc}</h4>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Errors/components/Layout.tsx